module.exports = __webpack_public_path__ + "img/p2-56.937dae9e.png";